export const events = {};

export const getArgumentsLists = (eventName, channel, params = {}, options = {}) => {
  options.config = channel.config;
  return channel.events[eventName] ? channel.events[eventName](params, options) : [];
};



// WEBPACK FOOTER //
// ./privates/events-mapper.js